<template>
    <component v-bind:is="layout"></component>
</template>

<script>
import AppLayout from '@/layouts/AppLayout'
import EmptyLayout from '@/layouts/EmptyLayout'
import { setLocaleAsync } from '@/i18n'

export default {
  computed: {
    layout () {
      return this.$store.getters['layoutModule/layout']
    }
  },
  components: {
    default: AppLayout,
    empty: EmptyLayout
  },
  mounted () {
    // watch application state for language changes
    this.$store.watch(
      (state) => this.$store.state.localeModule.locale,
      (newLanguage, oldLanguage) => {
        setLocaleAsync(newLanguage)
      }
    )
  }
}
</script>
